import { hooks as commonHooks } from '@sitebuilder/common';
import widgetsData from './WidgetsData';
import themeDocument from './ThemeDocument';

const WidgetsContainer = () => {
    const widgetInstances: any = themeDocument?.widgetInstances;
    const parentWidgetInstance = widgetInstances.root;

    const childWidgetInstanceIds = parentWidgetInstance.contentPlaceHolders.children;

    const appContext = commonHooks.useAppContext();

    return (
        <>
            {widgetInstances &&
                childWidgetInstanceIds &&
                childWidgetInstanceIds.map((childWidgetInstanceId: string, i: number) => {
                    const widgetInstance = widgetInstances[childWidgetInstanceId];
                    const properties = widgetInstance.properties;
                    const widget = appContext.widgetFactory.getWidget(widgetInstance.widgetId);

                    if (!widget) {
                        return null;
                    }

                    const Comp: any = widget.templateView;

                    return (
                        <div className="widgets-container" key={i}>
                            <div className="widget-title">{widgetInstance.widgetId} Widget</div>
                            <Comp
                                key={i}
                                widgetInstanceId={childWidgetInstanceId}
                                data={widgetsData}
                                properties={properties}
                                theme="default"
                            />
                        </div>
                    );
                })}
        </>
    );
};

export default WidgetsContainer;
